import { useMutation } from '@tanstack/react-query';
import { IMonitorComplaintsRequest, IMonitorComplaintsResponse } from '../../../viewmodels/CalendarViewModels';
import { useUserSession } from '../../../models/hooks/appStateHooks';

/**
 * Fire-after-save call that asks the platform to scan a meeting transcript for client complaints
 * (Custom Content / Website / Ads) and notify the responsible departments. Best-effort side effect
 * of saving a meeting note — see issue 18911 and the integration guide.
 */
export function useAdminMonitorComplaintsMutation() {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: (request: IMonitorComplaintsRequest) => {
			return userSession.webServiceHelper.callAsync<IMonitorComplaintsResponse>(
				'admin/zoom/transcripts/monitor',
				'POST',
				request
			);
		},
	});
}
